import styled from 'styled-components'

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 1.5em 0;

  .content {
    display: flex;
  }
  .searchFilter > * {
    margin-right: 8px;
  }
  .searchFilter {
    width: 100%;
    flex-direction: row;
  }
  .actions {
    display: flex;
  }
  .actions:first-child {
    margin-left: 0;
  }
  .actions > *:not(:last-child) {
    margin-right: 8px;
  }
  /* desktop */
  @media screen and (min-width:1040px) {
    .actions:first-child {
      margin-right: 0;
    }

    .actions {
      margin-left: auto;
      margin-right: 0;
    }
  }
`

export default StyledHeader
